const reasons = [
  {
    icon: "ri-exchange-line",
    title: "整体 × トレーニングの統合アプローチ",
    desc: "施術でほぐすだけでなく、トレーニングの知識も組み合わせることで、動ける身体を根本からつくります。",
  },
  {
    icon: "ri-body-scan-line",
    title: "身体の構造と動きをベースにした根本ケア",
    desc: "表面的なほぐしにとどまらず、骨格・筋膜・神経の状態を評価し、一人ひとりに合った施術を行います。",
  },
  {
    icon: "ri-shield-check-line",
    title: "完全予約制のプライベート空間",
    desc: "他のお客様を気にせず過ごせる完全個室。自分のペースで、じっくりと身体と向き合う時間をご提供します。",
  },
  {
    icon: "ri-leaf-line",
    title: "鎌倉の自然環境によるリラックスと回復効果",
    desc: "永福寺跡を見渡す静かな環境が、神経系の回復を後押し。自然の中にいるだけで、身体はほぐれ始めます。",
  },
];

export default function WhyKuu() {
  return (
    <section className="py-24 bg-[#faf8f2]">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[#3a4a28]/50 text-xs tracking-[0.4em] mb-4">WHY KUU</p>
          <h2 className="font-serif text-3xl md:text-4xl text-[#2a2a1e] mb-4">
            整えて、動ける身体になる。
          </h2>
          <p className="text-[#5a5a4a] text-sm leading-loose tracking-wide">
            施術とトレーニングを組み合わせた、KUUだけのアプローチ。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {reasons.map((reason, i) => (
            <div
              key={i}
              className="bg-white border border-[#e8e4d8] rounded-lg p-8 flex gap-5"
            >
              <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center bg-[#3a4a28]/8 rounded-full">
                <div className="w-6 h-6 flex items-center justify-center text-[#3a4a28]">
                  <i className={`${reason.icon} text-xl`} />
                </div>
              </div>
              <div>
                <h3 className="font-serif text-base text-[#2a2a1e] mb-3 tracking-wide">
                  {reason.title}
                </h3>
                <p className="text-[#5a5a4a] text-sm leading-loose tracking-wide">
                  {reason.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
